export const siteInfo = {
  name: '17.3关于性教育宣传片',
  tagline: '青少年性教育权威资源',
  description: '专为青少年设计的科学性教育视频内容，涵盖青春期知识、健康观念与自我保护意识，帮助家长、教师和学生正确认识性教育，树立健康积极的生命观与价值观。',
  url: 'https://www.173sexeducation.org',
  logo: '17.3',
  foundingYear: '2020',
  email: 'contact@173sexeducation.org',
  phone: '400-123-4567',
  address: '北京市朝阳区教育科技大厦 12 层',
  socialLinks: {
    wechat: '#',
    weibo: '#',
    bilibili: '#',
  },
  brandHighlights: [
    { number: '500万+', label: '累计观看人次' },
    { number: '3000+', label: '合作学校' },
    { number: '98%', label: '家长满意度' },
    { number: '50+', label: '权威专家团队' },
  ],
};

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '青春期知识', href: '/category/puberty' },
  { label: '自我保护', href: '/category/self-protection' },
  { label: '心理健康', href: '/category/mental-health' },
  { label: '家庭教育', href: '/category/family-education' },
  { label: '关于我们', href: '/about' },
];

export const brandHighlights = [
  { number: '500万+', label: '累计观看人次' },
  { number: '3000+', label: '合作学校' },
  { number: '98%', label: '家长满意度' },
  { number: '50+', label: '权威专家团队' },
];

export const brandIntro = {
  title: '关于 17.3 性教育宣传片',
  mission: '我们致力于为中国青少年提供科学、全面、适龄的性教育资源，帮助每一个孩子健康成长。',
  vision: '让每一个中国青少年都能获得高质量的性教育，拥有健康、自信、负责任的人生观。',
  history: [
    { year: '2020', event: '项目启动，第一部性教育宣传片上线' },
    { year: '2021', event: '与中国性学会达成战略合作，获得专业学术支持' },
    { year: '2022', event: '覆盖全国 1000+ 所学校，累计观看突破 200 万次' },
    { year: '2023', event: '推出系列课程体系，涵盖五大核心主题板块' },
    { year: '2024', event: '获教育部推荐，成为全国青少年健康教育指定资源' },
  ],
};

export const teamMembers = [
  { name: '李教授', role: '首席教育顾问', description: '中国性学会常务理事，从事青少年性教育研究 20 余年' },
  { name: '王博士', role: '心理学专家', description: '北京大学心理学博士，专注于青少年心理健康与性心理发展' },
  { name: '陈老师', role: '课程研发总监', description: '资深性教育课程设计师，拥有 15 年一线教学经验' },
  { name: '张医生', role: '医学顾问', description: '三甲医院妇产科主任医师，青少年生殖健康领域权威' },
];

export const certifications = [
  '中国性学会推荐教育资源',
  '教育部全国青少年健康教育指定资源',
  '联合国教科文组织性教育指导纲要参考资源',
  'ISO 9001 教育质量管理体系认证',
];